import { auth } from '../../redux/actions/authActions';
import { getAuth, signOut } from "firebase/auth";
import Cookies from 'js-cookie';

export const removeAuth = (dispatch) => {
    Cookies.remove('@EasyDev:user');
    dispatch(auth({ name: '', avatar: '' }));

    signOut(getAuth());
}